<template>
  <el-dialog
    :title="
      oneStepReturnObj.oneStepReturnType === 2
        ? '系统批量打回提醒'
        : '手动一键打回提醒'
    "
    :visible="currentVisible"
    width="50%"
    :close-on-click-modal="false"
    :before-close="close"
    class="dialog-transedit"
  >
    <el-row :span="24">
      <el-col :span="8">
        <img class="img" width="200px" src="/img/refuse.png" alt="" />
      </el-col>
      <el-col :span="8">
        <span style="color: blue">“{{ name }}”</span>
        <span>在本项目中的工作数据如下</span>
        <br />
        <span>已处理PE任务句数：{{ oneStepReturnObj.tj.submitSentNum }}</span>
        <br />
        <span>
          已手动确认无误句数：{{ oneStepReturnObj.tj.manualCorrectSentNum }}
        </span>
        <br />
        <span>
          已手动修改任务句数：{{ oneStepReturnObj.tj.manualUpdateSentNum }}
        </span>
        <br />
        <span>
          已手动打回任务池句数：{{ oneStepReturnObj.tj.manualReturnSentNum }}
        </span>
        <br />
        <span>
          系统已自动确认无误句数：{{ oneStepReturnObj.tj.autoCorrectSentNum }}
        </span>
        <br />
        <span>等待处理的数据：{{ oneStepReturnObj.tj.pendNum }}</span>
        <br />
      </el-col>
    </el-row>
    <el-row :span="24">
      <el-col :span="24">
        <span v-if="oneStepReturnObj.oneStepReturnType === 2">
          当前审核人审核的包已打回PE任务池数量已≥30%。
          <br />
        </span>
        <div>
          是否将
          <span style="color: blue">“{{ name }}”</span>
          等待处理的数据（共{{
            oneStepReturnObj.tj.sentNum
          }}句）全部打回任务池？同时将禁止其在此项目中继续领取审核任务。
        </div>
      </el-col>
    </el-row>
    <!-- todo 批量一键打回 -->
    <el-row :span="24">
      <el-col :span="24">
        <span style="color: red">
          该审核人员将无法收到译费，请务必勾选和填写批量打回任务池原因
        </span>
      </el-col>
    </el-row>
    <br />
    <el-form :model="oneStepReturnForm" :rules="rules" ref="oneStepReturnForm">
      <el-form-item prop="returnTag">
        <el-col :span="22" v-for="(item, index) in returnDic" :key="index">
          <el-checkbox-group v-model="oneStepReturnForm.returnTag">
            <el-checkbox
              v-for="(c, index) in item.list"
              :label="c.configKey"
              :key="index"
            >
              {{ c.configValue }}
            </el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-form-item>
      <el-form-item prop="remark">
        <el-input
          type="textarea"
          maxlength="200"
          show-word-limit
          :rows="4"
          placeholder="请输入批量打回任务的原因：例如未按照要项目术语提示进行修正、未按项目公告中的翻译要求处理等
  必填：最少输入5个字,该原因将会通过系统消息通知给译员"
          v-model="oneStepReturnForm.remark"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="btn-item" v-if="isQcOperate">
      <!-- 判断提交还是修改 -->
      <el-button
        type="danger"
        @click.stop="submitOneStepReturn('oneStepReturnForm')"
      >
        确定打回
      </el-button>
      <el-button type="info" @click.stop="close">我再想想</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { returnAllQcTask } from '@/api/qc/qcflow';
export default {
  props: [
    'visible',
    'returnDic',
    'oneStepReturnObj',
    'name',
    'isQcOperate',
    'qcTaskId',
    'lastAuditerId',
    'staffId',
  ],
  data() {
    return {
      currentVisible: false,
      oneStepReturnForm: {
        returnTag: [],
        remark: '',
      },
      rules: {
        returnTag: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个原因',
            trigger: 'change',
          },
        ],
        remark: [
          {
            required: true,
            message: '请输入批量打回任务的原因',
            trigger: 'blur',
          },
          {
            min: 5,
            max: 200,
            message: '长度在 5 到 200 个字符',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.currentVisible = true;
      }
    },
  },
  methods: {
    // 我再想想--关闭
    close() {
      this.$refs['oneStepReturnForm'].resetFields();
      this.isLoad = false;
      this.currentVisible = false;
      this.$emit('update:visible', false);
    },

    // 批量打回
    submitOneStepReturn(formName) {
      // todo 确定打回
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return;
        }
        const params = {
          flowId: this.$route.params.id,
          lastReviewer: this.lastAuditerId,
          qcMode: this.oneStepReturnObj.oneStepReturnType,
          qcTaskId: this.qcTaskId || this.$route.query.qcTaskId,
          operateQcTaskId: this.$route.query.qcTaskId,
          returnTag: this.oneStepReturnForm.returnTag.join(','),
          remark: this.oneStepReturnForm.remark,
          operateQcId: this.staffId,
        };
        // 一键打回
        returnAllQcTask(params).then((res) => {
          this.close();
          this.$router.replace({
            path: '/refresh',
          });
        });
      });
    },
  },
};
</script>
